// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__8SCII","obliqueLineWrap":"membershipbadge_obliqueLineWrap__pd68a","obliqueLine":"membershipbadge_obliqueLine__3Yl5n"};